/* TREVO storefront behaviour */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  /* Money in the visitor's currency, using the same format Shopify's money filter outputs */
  var fmt = (function () {
    var s = window.TV && TV.moneySample, m;
    if (s && (m = s.match(/1(\D?)234(\D)56/))) return { pre: s.slice(0, m.index), post: s.slice(m.index + m[0].length), th: m[1], dec: m[2], d: 2 };
    if (s && (m = s.match(/1(\D?)235/))) return { pre: s.slice(0, m.index), post: s.slice(m.index + m[0].length), th: m[1], dec: '', d: 0 };
    return { pre: '$', post: '', th: ',', dec: '.', d: 2 };
  })();
  function money(cents, whole) {
    var d = whole ? 0 : fmt.d, v = (cents / 100).toFixed(d).split('.');
    return fmt.pre + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.th) + (d ? fmt.dec + v[1] : '') + fmt.post;
  }
  window.TVmoney = money;

  /* Dollar amounts typed into text (FAQ, comparison, shipping...) are converted to the visitor's currency */
  function convertCopy(scope) {
    var cur = window.Shopify && Shopify.currency, rate = cur && +cur.rate;
    if (!cur || !rate || !window.TV || cur.active === TV.shopCurrency) return;
    var sel = '.tv-rte, .tv-faq__a, .tv-faq summary, .tv-acc summary, .tv-cmp__row > div, .tv-h2, .tv-h1, .tv-acc__a, .tv-sub__table td, .tv-ing__d, .tv-tl__d, .tv-ben__d, .tv-step, [data-tv-convert]';
    $$(sel, scope).forEach(function (el) {
      if (el._tvc || el.closest('[data-no-convert]')) return; el._tvc = 1;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, list = [];
      while ((n = w.nextNode())) if (n.nodeValue.indexOf('$') > -1) list.push(n);
      list.forEach(function (t) {
        t.nodeValue = t.nodeValue.replace(/\$(\d{1,3}(?:,\d{3})+|\d+)(\.\d{2})?(?![\d.])/g, function (all, intp, cents) {
          var usd = parseFloat(intp.replace(/,/g, '') + (cents || ''));
          return cents ? money(Math.round(usd * rate * 100)) : money(Math.round(usd * rate) * 100, true);
        });
      });
    });
  }

  /* Announcement rotation */
  function initAnn(scope) {
    $$('[data-tv-ann]', scope).forEach(function (bar) {
      if (bar._tv) return; bar._tv = 1;
      var msgs = $$('.tv-ann__msg', bar), i = 0;
      if (!msgs.length) return;
      msgs[0].classList.add('is-on');
      if (msgs.length < 2) return;
      var speed = parseInt(bar.getAttribute('data-speed') || '4', 10) * 1000;
      setInterval(function () {
        msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on');
      }, speed);
    });
  }

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tv-burger]');
    if (b) {
      var m = $('[data-tv-mnav]');
      if (m) { var open = m.classList.toggle('is-open'); b.setAttribute('aria-expanded', open); }
    }
  });

  /* Reviews: show all */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tv-more-revs]');
    if (!b) return;
    e.preventDefault();
    var s = b.closest('section');
    $$('.tv-rev.is-hidden', s).forEach(function (r) { r.classList.remove('is-hidden'); });
    b.remove();
  });

  function tvRich(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>'); }
  function tvScrollTo(el) {
    var h = $('.tv-header'); var off = (h ? h.getBoundingClientRect().height : 0) + 12;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
  }
  /* Sticky add to cart (simple products): scrolls back to the buy box */
  $$('[data-tv-sticky-simple]').forEach(function (st) {
    var target = document.getElementById(st.getAttribute('data-target')); if (!target) return;
    var watch = $('button[type=submit]', target) || target;
    $('button', st).addEventListener('click', function () { tvScrollTo(target); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { st.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(watch);
  });

  /* Cart drawer */
  var drawer;
  function cartCount(n) { $$('[data-tv-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n < 1; }); }
  function filterUpsells(cart) {
    var ids = cart.items.map(function (it) { return String(it.product_id); });
    $$('[data-tv-upsells]').forEach(function (u) {
      var shown = 0;
      $$('[data-product-id]', u).forEach(function (el) { var inCart = ids.indexOf(el.getAttribute('data-product-id')) > -1; el.hidden = inCart; if (!inCart) shown++; });
      u.hidden = !cart.items.length || !shown;
    });
  }
  function renderCart(cart) {
    drawer = drawer || $('[data-tv-drawer]');
    cartCount(cart.item_count);
    filterUpsells(cart);
    if (!drawer) return;
    var box = $('[data-tv-drawer-items]', drawer);
    var cnt = $('[data-tv-drawer-count]', drawer); if (cnt) cnt.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items.length) {
      box.innerHTML = '<div class="tv-drawer__empty">' + (drawer.getAttribute('data-empty') || 'Your cart is empty.') + '</div>';
    } else {
      box.innerHTML = cart.items.map(function (it, idx) {
        var img = it.featured_image && it.featured_image.url ? '<img src="' + it.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') + '" alt="">' : '';
        var plan = it.selling_plan_allocation ? '<div class="tv-line__v">' + it.selling_plan_allocation.selling_plan.name + '</div>' : '';
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="tv-line__v">' + it.variant_title + '</div>' : '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        var n = idx + 1;
        return '<div class="tv-line"><a class="tv-line__img" href="' + it.url + '">' + img + '</a><div class="tv-line__body"><a class="tv-line__t" href="' + it.url + '">' + it.product_title + '</a>' + vt + plan +
          '<div class="tv-line__ctrl"><div class="tv-qty"><button type="button" data-tv-qty="' + n + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button><span>' + it.quantity +
          '</span><button type="button" data-tv-qty="' + n + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
          '<button type="button" class="tv-line__rm" data-tv-qty="' + n + '" data-q="0">Remove</button></div></div><div class="tv-line__p">' + money(it.final_line_price) + was + '</div></div>';
      }).join('');
    }
    var t = $('[data-tv-drawer-total]', drawer); if (t) t.textContent = money(cart.total_price);
    var ck = $('[data-tv-checkout]', drawer); if (ck) ck.textContent = ck.getAttribute('data-label') + ' \u00b7 ' + money(cart.total_price);
    var saved = cart.items.reduce(function (s, it) { return s + Math.max(0, it.original_line_price - it.final_line_price); }, 0) + (cart.total_discount || 0) * 0;
    var sr = $('[data-tv-drawer-save-row]', drawer); if (sr) { sr.hidden = !saved; $('[data-tv-drawer-save]', drawer).textContent = '−' + money(saved); }
    var f = $('[data-tv-drawer-foot]', drawer); if (f) f.hidden = !cart.items.length;
  }
  function openDrawer() {
    drawer = drawer || $('[data-tv-drawer]');
    if (!drawer) { window.location.href = root + 'cart'; return; }
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  window.TVCart = { open: openDrawer, render: renderCart };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tv-open-cart]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-tv-close-cart]')) { e.preventDefault(); closeDrawer(); }
    var up = e.target.closest('[data-tv-upsell-add]');
    if (up) {
      up.disabled = true; up.classList.add('is-busy');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +up.getAttribute('data-tv-upsell-add'), quantity: 1 }] }) })
        .then(function () { if (document.querySelector('.tv-cartpg')) { window.location.reload(); return; } return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(renderCart); })
        .finally(function () { up.disabled = false; up.classList.remove('is-busy'); });
      return;
    }
    var q = e.target.closest('[data-tv-qty]');
    if (q) {
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +q.getAttribute('data-tv-qty'), quantity: Math.max(0, +q.getAttribute('data-q')) }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Product buy box */
  function initBuy(scope) {
    $$('[data-tv-buy]', scope).forEach(function (box) {
      if (box._tv) return; box._tv = 1;
      var dataEl = $('script[data-tv-buy-data]', box);
      if (!dataEl) return;
      var D = JSON.parse(dataEl.textContent);
      var mode = D.defaultMode === 'sub' && D.hasPlans ? 'sub' : 'ot';
      var sel = D.defaultIndex || 0;
      var btn = $('[data-tv-atc]', box), sticky = $('[data-tv-sticky]');
      function priceOf(o) { return mode === 'sub' && o.plan ? o.subPrice : o.price; }
      function cmpOf(o) {
        var c = 0;
        if (D.compareMode === 'base' && D.basePrice) c = D.basePrice * o.months;
        else if (D.compareMode === 'compare_at') c = o.compareAt || 0;
        else if (D.compareMode === 'supply' && o.compareFixed) c = Math.round(o.compareFixed * ((window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1));
        if (!c && mode === 'sub' && o.plan) c = o.price;
        return c > priceOf(o) ? c : 0;
      }
      function render() {
        $$('[data-tv-mode]', box).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-tv-mode') === mode); });
        $$('[data-tv-opt]', box).forEach(function (el, i) {
          var o = D.options[i]; if (!o) return;
          el.classList.toggle('is-on', i === sel); el.setAttribute('aria-checked', i === sel);
          var p = priceOf(o), c = cmpOf(o), m = D.perMonth ? Math.max(1, o.months) : 1, sfx = D.perMonth ? '/mo' : '';
          $('[data-now]', el).textContent = money(Math.floor(p / m)) + sfx;
          var was = $('[data-was]', el); was.textContent = c ? money(Math.floor(c / m)) + sfx : ''; was.hidden = !c;
          var pct = c ? Math.round((1 - p / c) * 100) : 0, sv = $('[data-save]', el);
          var sl = D.saveLabel || 'You save'; sv.textContent = sl.indexOf('[pct]') > -1 ? sl.replace('[pct]', pct) : sl + ' ' + pct + '%'; sv.hidden = pct < 1;
        });
        var o = D.options[sel] || D.options[0]; if (!o) return;
        var label = o.available ? D.atcLabel + ' \u2014 ' + money(priceOf(o)) : D.soldOutLabel;
        btn.textContent = label; btn.disabled = !o.available;
        if (sticky) { var sb = $('[data-tv-atc-sticky]', sticky); if (sb) { sb.textContent = label; sb.disabled = !o.available; } }
        var note = $('[data-tv-note]', box);
        if (note) note.innerHTML = tvRich(mode === 'sub' && o.plan ? (D.renewText || '').replace('[days]', o.months * 30).replace('[price]', money(o.subPrice)) : '');
      }
      box.addEventListener('click', function (e) {
        var m = e.target.closest('[data-tv-mode]'); if (m) { mode = m.getAttribute('data-tv-mode'); render(); }
        var op = e.target.closest('[data-tv-opt]'); if (op) { sel = $$('[data-tv-opt]', box).indexOf(op); render(); }
      });
      box.addEventListener('keydown', function (e) {
        var op = e.target.closest('[data-tv-opt]'); if (op && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); sel = $$('[data-tv-opt]', box).indexOf(op); render(); }
      });
      function add(b) {
        var o = D.options[sel]; var sub = mode === 'sub' && o.plan;
        var item = { id: sub ? o.subVariant : o.variant, quantity: 1 };
        if (sub) item.selling_plan = o.plan;
        var items = [item].concat((D.addOns || []).map(function (id) { return { id: id, quantity: 1 }; }));
        b.disabled = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            b.disabled = false;
            if (res.status && res.description) { alert(res.description); return; }
            if (D.afterAdd === 'checkout') window.location.href = root + 'checkout';
            else if (D.afterAdd === 'cart') window.location.href = root + 'cart';
            else openDrawer();
          }).catch(function () { b.disabled = false; });
      }
      btn.addEventListener('click', function () { add(btn); });
      if (sticky) {
        var sb = $('[data-tv-atc-sticky]', sticky); if (sb) sb.addEventListener('click', function () { tvScrollTo(box); });
        if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
      }
      render();
    });
  }

  /* Simple product (secondary products) */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-tv-simple-form]'); if (!f) return;
    e.preventDefault();
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json(); }).then(function (res) { if (res.status) alert(res.description); else openDrawer(); });
  });

  /* Gallery */
  function initGal(scope) {
    $$('[data-tv-gal]', scope).forEach(function (g) {
      if (g._tv) return; g._tv = 1;
      var slides = $$('.tv-gal__slide', g), thumbs = $$('.tv-gal__thumb', g);
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.classList.toggle('is-on', i === j); var v = $('video', s); if (v) { if (i === j) v.play().catch(function () {}); else v.pause(); } });
          thumbs.forEach(function (x, j) { x.classList.toggle('is-on', i === j); });
        });
      });
    });
  }

  /* Carousels */
  function initCarousel(scope) {
    $$('[data-tv-carousel].tv-carousel, [data-tv-carousel].tv-ings', scope).forEach(function (track) {
      if (track._tv) return; track._tv = 1;
      var sec = track.closest('section'), prev = $('[data-tv-prev]', sec), next = $('[data-tv-next]', sec);
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : track.clientWidth; }
      function upd() { if (prev) prev.disabled = track.scrollLeft < 4; if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  function init(scope) { convertCopy(scope); initAnn(scope); initBuy(scope); initGal(scope); initCarousel(scope); }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
